import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',  //网页一开始访问的路由 
    redirect: '/home' //重定向到home页面
  },
  {
    //整体布局页面
    path: '/',  
    name: 'layout',
    component: () => import('../views/index.vue'),
    //添加子路由 -> 作为子页面
    children:[
      //页面一
      {
        path: '/home',
        name: 'home',
        component: () => import('../views/main.vue'),
      },
      
      {
        path: '/products',
        name: 'products',
        component: () => import('../views/products/index.vue'),
        children:[
          //页面二
          {
            path: '/products/clinical',
            name: 'clinical',
            component: () => import('../views/products/clinical.vue'),
          },
          //页面三
          {
            path: '/products/commercial',
            name: 'commercial',
            component: () => import('../views/products/commercial.vue'),
          },
        ]
      },

      {
        path: '/services',
        name: 'services',
        component: () => import('../views/services/index.vue'),
        children:[
          //页面四
          {
            path: '/services/healthcare-cosulting',
            name: 'healthcare-cosulting',
            component: () => import('../views/services/healthcare-cosulting.vue'),
          },
        ]
      },
      //页面五
      {
        path: '/contact-us',
        name: 'contact-us',
        component: () => import('../views/contact-us.vue'),
      },

      //页面六
      {
        path: '/privacy-policy',
        name: 'privacy-policy',
        component: () => import('../views/privacy-policy.vue'),
      }
    ]
  },
]

const router = new VueRouter({
  // 添加 mode: 'history' 选项，去除ip中的#
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  //重置导航栏的状态
  const navMenuItems = document.querySelectorAll('.el-menu-item, .el-submenu');
  navMenuItems.forEach(item => {
    item.classList.remove('is-active');
  });

  next();
});

export default router